<template>
  <Dialog
    is-persistent
    :title="dialogTitle"
    :dialog="isOpened"
    :confirmation-button-text="confirmationButtonText"
    @confirmationAction="saveDivision"
  >
    <template #content>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-row>
          <v-col class="pb-4">
            <v-text-field
              v-model="divisionName"
              class="secondary-background"
              label="Name"
              :rules="nameRules"
              required
              hide-details="auto"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-4">
            <v-checkbox
              v-model="canCreateProjectsFromUi"
              label="Allow creating projects from the ETS interface"
              hide-details
              dense
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
  </Dialog>
</template>

<script>
import { Dialog } from '@/components/shared';

export default {
  components: {
    Dialog,
  },
  props: {
    isOpened: {
      type: Boolean,
      required: true,
    },
    division: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      valid: false,
      divisionName: '',
      canCreateProjectsFromUi: true,
      nameRules: [
        (v) => !!v || 'Name is required',
        (v) => (v && v.length > 0) || 'Name cannot be empty',
      ],
    };
  },
  computed: {
    dialogTitle() {
      return this.division ? 'Edit Division' : 'Add Division';
    },
    confirmationButtonText() {
      return this.division ? 'Save' : 'Add';
    },
  },
  watch: {
    isOpened(newVal) {
      if (newVal) {
        this.divisionName = this.division ? this.division.name : '';
        this.canCreateProjectsFromUi = this.division
          ? this.division.can_create_projects_from_ui
          : true;
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        });
      }
    },
  },
  methods: {
    async saveDivision(confirmed) {
      if (!confirmed) {
        return this.closeDialog();
      }

      if (!this.$refs.form.validate()) {
        return;
      }

      this.$emit('save', {
        name: this.divisionName,
        id: this.division ? this.division.id : null,
        canCreateProjectsFromUi: this.canCreateProjectsFromUi,
      });
    },
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="less">
@import "~variables";
</style>

